import { toast } from 'sonner';

import { useUpdateCandidateJobHiringStatusMutation } from '@/modules/candidates/mutations/useUpdateCandidateJobHiringStatusMutation';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/modules/ui/components/select/Select';
import { extractErrorMessage } from '@/utils/extractErrorMessage';

export interface HiringStatusDropdownProps {
  jobId: string;
  candidateId: string;
  currentStatus?: string | null;
  hiringStages?: string[] | null;
}

export const HiringStatusDropdown = ({
  jobId,
  candidateId,
  currentStatus,
  hiringStages,
}: HiringStatusDropdownProps) => {
  const updateHiringStatusMutation = useUpdateCandidateJobHiringStatusMutation(
    jobId,
    candidateId,
  );

  const handleStatusChange = (newStatus: string) => {
    updateHiringStatusMutation.mutate(
      { status: newStatus },
      {
        onError: (error) => {
          toast.error(
            `Hiring status has not been updated: ${extractErrorMessage(error)}`,
          );
        },
        onSuccess: () => {
          toast.success(`Hiring status has been updated`);
        },
      },
    );
  };

  if (!hiringStages || hiringStages.length === 0) {
    return (
      <Select disabled>
        <SelectTrigger className="min-w-[140px]">
          <SelectValue placeholder="No hiring stages defined" />
        </SelectTrigger>
      </Select>
    );
  }

  return (
    <Select
      value={currentStatus || undefined}
      onValueChange={handleStatusChange}
      disabled={updateHiringStatusMutation.isPending}
    >
      <SelectTrigger className="min-w-[140px]">
        <SelectValue placeholder="Select status" />
      </SelectTrigger>
      <SelectContent>
        {hiringStages.map((stage) => (
          <SelectItem key={stage} value={stage}>
            {stage}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
